import { Button, Tooltip } from 'plume-ui';
import {
  DataRow,
  Heading,
  SortDirection,
} from 'plume-ui/dist/components/Table/Table';
import { ConfigurationInfoModalData, Maybe } from '../../../../types';
import FormattedMessage from '../../../../utils/components/FormattedMessage';
import i18n from '../../../../utils/i18n';
import { ConfigurationCTAUrlResponse } from '../../../Monitor/types';
import ActionCell from '../Webhook/renderers/tableCellAction';

export const parseUrlToDataRows = (
  data: ConfigurationCTAUrlResponse[],
): DataRow[] => {
  return data.map((row) => {
    return {
      urlLink: row.urlLink,
      noOfSubscriberOutreach: `${row.monitorDetails?.length}`,
      action: row.id,
    };
  });
};

export const urlListTableHeaders = ({
  urlList,
  openOutreachListModal,
  editUrl,
  deleteUrl,
  editAllowed,
  testUrl,
}: {
  urlList: ConfigurationCTAUrlResponse[];
  openOutreachListModal: (data: Maybe<ConfigurationInfoModalData>) => void;
  editUrl: (id: string) => void;
  deleteUrl: (id: string) => void;
  editAllowed: boolean;
  testUrl: (urlLink: string) => void;
}): Heading[] => [
  {
    name: i18n.t('configuration.url.urlLink'),
    fieldName: 'urlLink',
    render: (rowData: DataRow) => {
      const urlLink = rowData.urlLink;
      return (
        <>
          {urlLink.length > 22 ? (
            <Tooltip
              position="below"
              alignment="left"
              label={urlLink}
              overrideMaxCharacters
              openInPortal
            >
              <div>{urlLink}</div>
            </Tooltip>
          ) : (
            <div>{urlLink}</div>
          )}
          <Button styleVariant="tertiary" onClick={() => testUrl(urlLink)}>
            <FormattedMessage id="configuration.actions.test" />
          </Button>
        </>
      );
    },
  },
  {
    name: i18n.t('configuration.webhooks.monitors'),
    fieldName: 'supportOutreach',
    render: (rowData: DataRow) => (
      <div className="Configuration__collapseCard__webhook__table__rendered-cell">
        <div className="Configuration__collapseCard__webhook__table__rendered-cell__monitors">
          {rowData.noOfSubscriberOutreach}
          <Button
            styleVariant="tertiary"
            onClick={() => {
              openOutreachListModal({
                outreachId: rowData.action,
                monitorDetails: urlList.find(
                  (item) => item.id === rowData.action,
                )?.monitorDetails,
              });
            }}
          >
            <FormattedMessage id="configuration.webhooks.more" />
          </Button>
        </div>
      </div>
    ),
    sortFnGen: (sortDir: SortDirection) => {
      return (a, b) => {
        return +a.noOfSubscriberOutreach < +b.noOfSubscriberOutreach
          ? 1 * sortDir
          : -1 * sortDir;
      };
    },
    sortable: true,
  },
  {
    name: i18n.t('configuration.webhooks.action'),
    render: (rowData: DataRow) => (
      <ActionCell
        id={rowData.action}
        edit={editUrl}
        del={deleteUrl}
        editAllowed={editAllowed}
      />
    ),
  },
];
